import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// ROUTER
import { withRouter } from "../../utils/withRouter";
// CANVAS
import AlertBanner from "canvas-core-react/lib/AlertBanner";
import Column from "canvas-core-react/lib/Column";
import TextBody from "canvas-core-react/lib/TextBody";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import Margin from "canvas-core-react/lib/Margin";
import TextHeadline from "canvas-core-react/lib/TextHeadline";
import Row from "canvas-core-react/lib/Row";


// COMPONENTS
import Layout from "../Layout/Layout";
import Foot from "../Layout/Foot";

import { ReactComponent as icon } from '../../components/icons/icon_payment.svg';
import IconPaymentError from "../icons/IconPaymentError";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import BrandLine from "../BrandLine";

const paymentErrorGeneric = ({ navigate }) => {

	return (
		<>
			<>
				<Layout idBlackBanner={0} showBanner={false}>
					{/* BANNER */}
					<Column lg={12} lgOffset={0}>
						<Margin side="top" lg={24} />
						<Row justifyContent="center" style={{ textAlign: 'center' }}>
							<Column
								xs={4}
								sm={8}
								md={10}
								lg={10}
							>
								<Margin side="top" xs={90} sm={60} md={60} lg={60}>
									<IconPaymentError />
								</Margin>
								<Margin side="top" xs={0} sm={24} md={24} lg={24}>
									<TextSubtitle type="1" component="h3">
										¡Vaya!
									</TextSubtitle>
									<TextSubtitle type="1" component="h3">
										Ha ocurrido un error
									</TextSubtitle>
								</Margin>
								<Margin side="top" xs={12} sm={24} md={24} lg={24}>
									<BrandLine />
								</Margin>
								<Margin xs={18} sm={36} md={0} lg={0}>
									<TextBody component="p">
										Por el momento, no se puede realizar el pago de tu Depósito a Plazo.<br/>
										Por favor, vuelve a intentarlo.
									</TextBody>
								</Margin>
								<Margin side="top" xs={12} sm={24} md={60} lg={60}></Margin>
								<PrimaryButton
									id={'buttonId'}
									labelPadding={36}
									style={{ width: '200px' }}
									onClick={() => {
										navigate('/')
									}
									}
								>
									Reintentar
								</PrimaryButton>
							</Column>
						</Row>
					</Column>
				</Layout>
				<Foot />
			</>

		</>
	);
}

export default withRouter(paymentErrorGeneric);